import React, { Component } from 'react';
import { isEqual } from 'lodash';

class ToggleSortButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active,
    };
  }

  componentDidMount() {
    this.setState({ active: isEqual(this.props.sortBy, this.props.value) });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!isEqual(prevProps.sortBy, this.props.sortBy)) {
      this.setState({ active: isEqual(this.props.sortBy, this.props.value) });
    }
  }

  render() {
    const {
      defaultCaption,
      toggledCaption,
      defaultClass,
      toggledClass,
      sortingFieldUpdate,
      value,
    } = this.props;

    const active = this.state.active;
    const classes = defaultClass + ' ' + (active ? toggledClass : '');

    return (
      <button
        className={classes}
        onClick={() => {
          sortingFieldUpdate(value);
        }}
      >
        {active ? toggledCaption : defaultCaption}
      </button>
    );
  }
}

export default ToggleSortButton;
